/**
 * Soft role colours for Pos marks (pitch + Select Players list).
 * DEF blues, MID greens, FWD reds; bridges for DM and wings.
 */
export const SLOT_ROLE_COLOR = {
  GK: { fg: '#475569', bg: 'rgba(71,85,105,.16)' },
  CB: { fg: '#1e3a8a', bg: 'rgba(30,58,138,.18)' },
  LB: { fg: '#38bdf8', bg: 'rgba(56,189,248,.16)' },
  RB: { fg: '#38bdf8', bg: 'rgba(56,189,248,.16)' },
  DM: { fg: '#0e7490', bg: 'rgba(14,116,144,.16)' },
  CM: { fg: '#166534', bg: 'rgba(22,101,52,.16)' },
  CAM: { fg: '#4ade80', bg: 'rgba(74,222,128,.16)' },
  LW: { fg: '#ca8a04', bg: 'rgba(202,138,4,.16)' },
  RW: { fg: '#ca8a04', bg: 'rgba(202,138,4,.16)' },
  ST: { fg: '#dc2626', bg: 'rgba(220,38,38,.16)' },
};

export const slotRoleStyle = (label) => {
  const tone = SLOT_ROLE_COLOR[label];
  if (!tone) return undefined;
  return { color: tone.fg, background: tone.bg };
};
